import { useState } from "react";

const getDescription = (
  description
) => {
  if (Array.isArray(description)) {
    return description.filter(Boolean);
  }

  if (
    typeof description === "string" &&
    description.trim()
  ) {
    return [description];
  }

  return [];
};

const Cats = ({
  items = [],
  category = "",
  loading = false,
  image,
}) => {
  const [selectedItem, setSelectedItem] =
    useState(null);

  if (loading) {
    return (
      <div className="tubbeesMenuLoading">
        <div className="tubbeesMenuLoader" />

        <span>
          LOADING MENU
        </span>
      </div>
    );
  }

  if (!items.length) {
    return (
      <div className="tubbeesMenuEmpty">
        <span>NO ITEMS FOUND</span>

        <h3>
          Nothing here yet.
        </h3>

        <p>
          Try another category or
          search.
        </p>
      </div>
    );
  }

  // Sort API items alphabetically in ascending order
  const sortedItems = [...items].sort((a, b) =>
    String(a.name || "").localeCompare(
      String(b.name || ""),
      undefined,
      { sensitivity: "base" }
    )
  );

  return (
    <>
      <section className="tubbeesProductSection">

        <div className="tubbeesProductSectionHead">

          <div>
            <span>
              {String(
                category
              ).toUpperCase()}
            </span>

            <h3>
              {String(category)
                .replace(
                  /\b\w/g,
                  (letter) =>
                    letter.toUpperCase()
                )}
            </h3>
          </div>

          <p>
            {sortedItems.length}{" "}
            {sortedItems.length === 1
              ? "item"
              : "items"}
          </p>

        </div>

        <div className="tubbeesProductGrid">

          {sortedItems.map(
            (item, index) => (
              <button
                type="button"
                className="tubbeesProduct"
                key={`${item.name}-${index}`}
                onClick={() =>
                  setSelectedItem(
                    item
                  )
                }
              >

                <div className="tubbeesProductImage">

                  <span className="tubbeesProductNumber">
                    {String(
                      index + 1
                    ).padStart(
                      2,
                      "0"
                    )}
                  </span>

                  <img
                    src={image}
                    alt={item.name}
                    loading="lazy"
                  />

                  <div className="tubbeesProductView">
                    <span>
                      VIEW
                    </span>

                    <strong>
                      ↗
                    </strong>
                  </div>

                </div>

                <div className="tubbeesProductInfo">

                  <h4>
                    {item.name}
                  </h4>

                  {getDescription(
                    item.description
                  ).length > 0 && (
                    <p>
                      {getDescription(
                        item.description
                      )
                        .slice(0, 2)
                        .join(" • ")}
                    </p>
                  )}

                  <span>
                    FIND OUT MORE
                    <strong>
                      →
                    </strong>
                  </span>

                </div>

              </button>
            )
          )}

        </div>

      </section>

      {selectedItem && (
        <div
          className="tubbeesProductOverlay"
          onClick={() =>
            setSelectedItem(null)
          }
        >

          <div
            className="tubbeesProductModal"
            onClick={(event) =>
              event.stopPropagation()
            }
          >

            <button
              type="button"
              className="tubbeesProductClose"
              onClick={() =>
                setSelectedItem(null)
              }
              aria-label="Close"
            >
              ×
            </button>

            <div className="tubbeesProductModalImage">

              <img
                src={image}
                alt={selectedItem.name}
              />

            </div>

            <div className="tubbeesProductModalCopy">

              <span>
                {String(
                  category
                ).toUpperCase()}
              </span>

              <h2>
                {selectedItem.name}
              </h2>

              <div className="tubbeesProductModalLine" />

              {getDescription(
                selectedItem.description
              ).length > 0 && (
                <div className="tubbeesProductIngredients">

                  <small>
                    WHAT'S INSIDE
                  </small>

                  {getDescription(
                    selectedItem.description
                  ).map(
                    (
                      description,
                      index
                    ) => (
                      <div
                        key={`${description}-${index}`}
                      >

                        <span>
                          {String(
                            index + 1
                          ).padStart(
                            2,
                            "0"
                          )}
                        </span>

                        <p>
                          {description}
                        </p>

                      </div>
                    )
                  )}

                </div>
              )}

              <button
                type="button"
                className="tubbeesProductBack"
                onClick={() =>
                  setSelectedItem(null)
                }
              >
                BACK TO MENU
                <span>
                  →
                </span>
              </button>

            </div>

          </div>

        </div>
      )}

    </>
  );
};

export default Cats;